import React from "react";
import Productlistcard from "../components/Productlistcard2";
 // Import JSON directly

const Products = () => {
  

  return (
    <section className="text-black">
      <div className="container mx-auto  mt-12">
        <h2 className="text-3xl md:text-4xl font-bold text-center">All Products</h2>
        <p className="mb-8 text-center">Shop our effective, transparent, and research-backed skincare and haircare range, meticulously formulated to address your unique skin and hair concerns.</p>
        <Productlistcard/>
      </div>
    </section>
  );
};

export default Products;
